import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { AccordionContext, useAccordionToggle } from 'react-bootstrap';
import styles from './Collapsible.module.scss';

interface ICollapsibleToggle {
  eventKey: string;
}

const CollapsibleToggle = (props: ICollapsibleToggle) => {
  const currentEventKey = useContext(AccordionContext);
  const { eventKey } = props;
  const handleClick = useAccordionToggle(eventKey);
  const isCurrentEventKey = currentEventKey === eventKey;
  return (
    <button type="button" onClick={handleClick} className={styles.toggler}>
      {isCurrentEventKey ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}
    </button>
  );
};

export default CollapsibleToggle;
